import { render, staticRenderFns } from "./input-type.vue?vue&type=template&id=17123e31&scoped=true"
import script from "./input-type.vue?vue&type=script&lang=ts"
export * from "./input-type.vue?vue&type=script&lang=ts"
import style0 from "./input-type.vue?vue&type=style&index=0&id=17123e31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17123e31",
  null
  
)

export default component.exports